import Navigation from "../../../src/core/gd/navigation"

export default class SharedNavigation extends Navigation {

    private urlPrefix: string

    constructor() {
        super()

        const path = window.location.pathname.split('/')
        this.urlPrefix = path[1] + '/'
    }

    goToTimeReport(timeReportId:ID) {
        this.goTo(this.urlPrefix + 'time-report/'+timeReportId);
    }

    goToTask(taskId:ID) {
        this.goTo(this.urlPrefix + 't/'+taskId);
    }

    goToExpense(expenseId:ID) {
        this.goTo(this.urlPrefix + 'expense/'+expenseId)
    }
}